module.exports = {

    type: {
        STRING: 1,
        // BOOLEAN: 2,
        NUMBER: 3,
        // CURRENCY: 4,
        // PERCENTAGE: 5,
        DATE: 6,
        DROPDOWN: 7,
        // RATING: 8,
        // EMAIL: 9,
        // PHONE: 10,
        // URL: 11,
        // USER: 12,
        TEXT: 13
    },

    list: [
        // 1,13,2,3,4,5,6,7,8,9,10,11,12
        1,13,3,6,7
    ],

    // STRING
    1: {
        id: 1,
        label: 'String',
        icon: 'i5-text'
    },

    // BOOLEAN
    // 2: {
    //     id: 2,
    //     label: 'Checkbox',
    //     icon: 'i5-checkbox'
    // },

    // NUMBER
    3: {
        id: 3,
        label: 'Number',
        icon: 'i5-numbers'
    },

    // DATE
    6: {
        id: 6,
        label: 'Date',
        icon: ' i5-calendar'
    },

    // LIST
    7: {
        id: 7,
        label: 'Dropdown',
        icon: 'i5-dropdown'
    },

    // RATING
    // 8: {
    //     id: 8,
    //     label: 'Rating',
    //     icon: 'i5-star'
    // },
    //
    // // EMAIL
    // 9: {
    //     id: 9,
    //     label: 'Email',
    //     icon: 'i5-email'
    // },
    // // EMAIL
    // 10: {
    //     id: 10,
    //     label: 'Phone',
    //     icon: 'i5-phone'
    // },

    // // USER
    // 12: {
    //     id: 12,
    //     label: 'User',
    //     icon: 'i5-user'
    // },

    // TEXT
    13: {
        id: 13,
        label: 'Text',
        icon: 'editor-i5-insert'
    },


};